import clsx from 'clsx';
import { Box } from '@material-ui/core';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';

import { SText } from '@setvi/shared/components';

import { useBadgeStyles } from './styles';

interface InCartBadgeProps {
  /**
   * `medium` (default) for card thumbnails; `small` is a compact variant for
   * inline placement next to text (e.g. table rows).
   */
  size?: 'medium' | 'small';
}

export const InCartBadge = ({ size = 'medium' }: InCartBadgeProps) => {
  const classes = useBadgeStyles();
  const small = size === 'small';

  return (
    <Box className={clsx(classes.root, { [classes.small]: small })}>
      <CheckRoundedIcon className={small ? classes.iconSmall : classes.icon} />
      <SText
        title="In Cart"
        size="xs"
        weight="semibold"
        fontColor="#fff"
        style={small ? { fontSize: 11, lineHeight: '14px' } : undefined}
      />
    </Box>
  );
};
